import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../../application/config/config';
import Fetch from "../../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../../helpers/chooseProfileFilter";


function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id
    }

    const path = '/entities/';
    const paths = {
        endpointSave: config.endpoints.backend + 'entities/save',
        endpointGetById: config.endpoints.backend + 'entities/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetOneEntity: config.endpoints.backend + 'entities/getone',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleEdit: "Configurações do Portal"
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Logo',
                    uploadPath: '/entities/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'background_image',
                    type: 'file',
                    label: 'Imagem de Background - Portal de Transparência',
                    uploadPath: '/entities/',
                    extensionAccept: '.jpeg,.jpg,.png',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'primary_color',
                    type: 'color',
                    label: 'Cor primária',
                    validations: {
                        required: true
                    },
                    columnSize: 2
                },
                {
                    name: 'secondary_color',
                    type: 'color',
                    label: 'Cor de fundo',
                    validations: {
                        required: true
                    },
                    columnSize: 2
                },
                {
                    name: 'content_color',
                    type: 'select',
                    options: [
                        { label: 'Escuro', value: '#000000' },
                        { label: 'Claro', value: '#FFFFFF' }
                    ],
                    label: 'Cor do conteudo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'friendly_url',
                    type: 'text',
                    label: 'URL Amigável',
                    validations: {
                        required: true,
                        verifyFriendlyUrl: true
                    },
                    columnSize: 12
                },
                {
                    name: 'theme',
                    type: 'select',
                    label: 'Tema',
                    options: [
                        { label: 'Tema 1', value: '1' },
                        { label: 'Tema 2', value: '2' },
                        { label: 'Tema 3', value: '3' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'employee_payment_portal_view',
                    type: 'select',
                    label: 'Visualização de Folha de Pagamento',
                    options: [
                        { label: 'Por Empregado', value: 'EMPLOYEE' },
                        { label: 'Por Departamento', value: 'DEPARTMENT' }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                verifyFriendlyUrl: async (value, options, key, attributes) => {
                    if (attributes.friendly_url) {
                        const verifyData = await Fetch.post(paths.endpointGetOneEntity, {
                            filter: {
                                friendly_url: attributes.friendly_url,
                                deleted: '0'
                            }
                        })
                        
                        if (verifyData && verifyData.friendly_url == attributes.friendly_url && verifyData.id != id) {
                            return '^ Já existe uma entidade com essa URL.'
                        }else{
                            return ''
                        }
                    } else {
                        return ''
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
